var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 0H3.2C1.43269 0 0 1.43269 0 3.2V28.8C0 30.5673 1.43269 32 3.2 32H28.8C30.5673 32 32 30.5673 32 28.8V3.2C32 1.43269 30.5673 0 28.8 0Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7374 6.3999C15.8294 6.3999 15.923 6.4151 16.0118 6.4463L23.6926 9.0591C24.0406 9.1767 24.2742 9.5023 24.2742 9.8695V15.7479C24.2742 18.6639 22.9406 21.3079 20.3102 23.6063C18.271 25.3879 16.1606 26.2959 16.0742 26.3319C15.8558 26.4231 15.6166 26.4231 15.4022 26.3319C15.3134 26.2943 13.2038 25.3871 11.1638 23.6055C8.5334 21.3071 7.1998 18.6639 7.1998 15.7479V9.8695C7.1998 9.5039 7.4342 9.1775 7.7822 9.0591L15.463 6.4455C15.551 6.4151 15.6438 6.3999 15.7374 6.3999ZM15.7374 8.1623L8.9142 10.4831V15.7479C8.9142 20.7767 14.0534 23.7511 15.6278 24.5431L15.7358 24.5975L15.8438 24.5431C17.4198 23.7447 22.5598 20.7511 22.5598 15.7479V10.4831L15.7374 8.1623ZM20.2742 12.4233C20.4566 12.5609 20.5758 12.7617 20.6078 12.9881C20.6398 13.2145 20.5814 13.4401 20.4446 13.6233L16.055 19.4753C15.907 19.6737 15.679 19.7985 15.431 19.8153L15.4198 19.8161C15.4038 19.8185 15.3878 19.8177 15.3718 19.8177C15.1454 19.8177 14.9246 19.7265 14.7654 19.5657L11.8406 16.6401C11.5054 16.3065 11.5054 15.7625 11.8406 15.4273C12.0078 15.2601 12.227 15.1761 12.4462 15.1761C12.6654 15.1761 12.8862 15.2601 13.0526 15.4273L15.2806 17.6553L19.075 12.5937C19.2102 12.4121 19.4094 12.2937 19.635 12.2609C19.8622 12.2273 20.0902 12.2849 20.2742 12.4233Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/safe.f460e712e948b4513f48b8a36714a8ec.svg";
export { ForwardRef as ReactComponent };